import React, {Component} from "react";

export default class Hyperlink extends Component
{
	render()
	{
		let props =
		{
			href: this.props.href,
			className: this.props.className,
			style: this.props.style,
		};

		if(this.props.newTab)
		{
			props.target = "_blank";
			props.rel = "noopener noreferrer";
		}

		return (
			<a {...props}>
				{this.props.children}
			</a>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Hyperlink/Hyperlink.js